module.exports = __webpack_public_path__ + "media/images/icons/icon_form_error-22896159ed06a273b9fe8e95bc0b4943.svg";